import React, { useContext, useEffect, useState } from "react";
import "../../Dashboard/View_List/View_List.css";
import Add from "./Add";
import Edit from "./Edit";
import Delete_Points_Modal from "../../Common_Component/Common_Modal/Delete_Points_Modal/Delete_Points_Modal";
import { Button, Form, InputGroup, Modal, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMinus,
  faPenToSquare,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FixIDS } from "../../../utils/fixIDS";
import {
  findAll,
  Delete,
  Status,
  Deposit,
  Withdrawal,
} from "../../../utils/apis/agentManagement/customer/index";
import {
  formatAmount,
  formatDate,
  IDS,
  Per_Page_Dropdown,
} from "../../../utils/common";
import Pagination_holder from "../../Common_Component/Pagination_holder/Pagination_holder";
import CustomPaginate from "../../Common_Component/CustomPaginate/CustomPaginate";
import { Context } from "../../../utils/context";
import Heading_Holder from "../../Common_Component/Heading_Holder/Heading_Holder";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";
import { useNavigate, useSearchParams } from "react-router-dom";

const Tables = () => {
  const { UnauthorizedLogOut, IMG_URL, isAllow } = useContext(Context);

  const [modalShow, setModalShow] = useState(false);
  const [modalEditShow, setModalEditShow] = useState(0);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [showModal, setShowModal] = useState({ code: 0, message: "" });

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(10);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [changeStatus, setChangeStatus] = useState();
  const [searchContactNo, setSearchContactNo] = useState("");

  // Money Modal States
  const [moneyAction, setMoneyAction] = useState(null); // "Credit" or "Debit"
  const [selectedUser, setSelectedUser] = useState(null);
  const [amount, setAmount] = useState("");
  const [showMoneyModal, setShowMoneyModal] = useState(false);
  const [moneyLoading, setMoneyLoading] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const statusFromUrl = searchParams.get("status");

  const [status, setStatus] = useState(statusFromUrl || "");

  const getDataAll = async () => {
    try {
      const response = await findAll(
        currentPage,
        perPage,
        search,
        searchContactNo,
        status,
      );
      setData(response?.data);
      setCurrentPage(response?.data?.data?.current_page || 1);
      setperPage(response?.data?.data?.per_page || 10);
      // setOption(await Per_Page_Dropdown(response?.data?.data?.total));
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  const handleMoneyAction = (type, userId) => {
    setMoneyAction(type);
    setSelectedUser(userId);
    setAmount("");
    setShowMoneyModal(true);
  };

  useEffect(() => {
    getDataAll();
  }, [
    search,
    searchContactNo,
    changeStatus,
    perPage,
    reset,
    modalShow,
    modalEditShow,
    currentPage,
    status,
  ]);

  const StatusChange = async (id) => {
    const response = await Status(id);
    setChangeStatus(response);
  };

  const handleDeleteRecord = async () => {
    setModalDeleteShow(false);
    if (recordToDeleteId) {
      const response = await Delete(recordToDeleteId);
      setShowModal({
        code: response.data.code,
        message: response.data.data || "Record deleted successfully",
      });

      setTimeout(() => setShowModal({ code: 0, message: "" }), 2000);
      setRecordToDeleteId(null);
      setChangeStatus(response);
    }
  };

  // ✅ Corrected handleMoneySubmit
  const handleMoneySubmit = async () => {
    if (!amount || Number(amount) <= 0) return;

    setMoneyLoading(true);

    try {
      const payload = {
        user_id: selectedUser,
        amount: Number(amount),
      };

      let res;
      if (moneyAction === "Credit") {
        res = await Deposit(payload);
      } else if (moneyAction === "Debit") {
        res = await Withdrawal(payload);
      }

      // Handle Success
      if (res?.data?.code === 200 || res?.data?.code === 201) {
        let message = `${moneyAction} successful!`;

        if (typeof res?.data?.data === "string") {
          message = res.data.data;
        } else if (res?.data?.data?.message) {
          message = res.data.data.message;
        } else if (res?.data?.data?.amount) {
          message = `₹${res.data.data.amount} has been ${moneyAction === "Credit" ? "added" : "deducted"} successfully`;
        }

        setShowModal({
          code: 200,
          message: message,
        });
      }
      // Handle API Error Response
      else {
        const errorMsg =
          res?.data?.errors ||
          res?.data?.message ||
          "Operation failed. Please try again.";

        setShowModal({
          code: 400,
          message:
            typeof errorMsg === "string" ? errorMsg : "Something went wrong",
        });
      }
    } catch (error) {
      // Handle Network / Exception Error
      console.error(error);
      const errorMsg =
        error?.response?.data?.errors ||
        error?.response?.data?.message ||
        "An unexpected error occurred";

      setShowModal({
        code: 400,
        message:
          typeof errorMsg === "string" ? errorMsg : "Something went wrong",
      });
    } finally {
      setMoneyLoading(false);

      // Auto close modal after 2 seconds (for both success and error)
      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        setShowMoneyModal(false);
        getDataAll();
      }, 2000);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const navigate = useNavigate();
  return (
    <>
      <section className="View_List">
        <Heading_Holder headingText={"Customer"} />
        <div className="search-bar-holder ">
          <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5    ">
            <Form.Group className="form-field" controlId="formBasicEmail">
              <Form.Control
                type="text"
                placeholder="User Name"
                onChange={(e) => setSearch(e.target.value)}
                value={search}
                className="mt-1"
              />
            </Form.Group>
            <Form.Group className="form-field" controlId="formBasicEmail">
              <Form.Control
                type="text"
                placeholder="User Contact"
                onChange={(e) => setSearchContactNo(e.target.value)}
                value={searchContactNo}
                className="mt-1"
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Status</Form.Label>

              <Form.Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                className="mt-1">
                <option value="">All</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </Form.Select>
            </Form.Group>
            <Button
              type="button"
              className="reset-btn mt-2"
              onClick={() => {
                setSearch("");
                setSearchContactNo("");
                setStatus("");
                setReset(!reset);
              }}>
              Reset
            </Button>
          </div>
          <Form>
            <div className="row align-items-end">
              {isAllow?.includes(46) && (
                <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5 col-holder">
                  <Button
                    type="button"
                    className="search-btn"
                    onClick={() => setModalShow(true)}>
                    Add
                  </Button>
                </div>
              )}
            </div>
          </Form>
        </div>

        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="user-list-table">
              <div className="data-table-holder">
                <Table
                  striped
                  bordered
                  hover
                  responsive
                  className="text-center">
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Name</th>
                      <th>Added By</th>
                      <th>UID</th>
                      <th>Contact no</th>
                      <th>Email</th>
                      <th>Balance</th>
                      <th>Available</th>
                      <th>Password</th>
                      <th>Date Joined</th>
                      <th>Your Share</th>
                      <th>His Share</th>
                      <th>Wallet History</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.data?.data?.length > 0 ? (
                      data.data.data.map((val, index) => (
                        <tr key={index}>
                          <td>
                            {(data.data.current_page - 1) * data.data.per_page +
                              index +
                              1}
                          </td>
                          <td>{val?.name}</td>
                          <td>{val?.added_by?.name}</td>
                          <td>{val?.user_uid}</td>
                          <td>{val?.contact_no || "N/A"}</td>
                          <td>{val?.email || "N/A"}</td>
                          <td>
                            {formatAmount(val?.Wallet?.deposite_amount) || "0"}
                          </td>
                          <td>{formatAmount(val?.Wallet?.amount) || "0"}</td>
                          <td>{val?.show_password || "N/A"}</td>
                          <td>
                            {val.id !== 1 && formatDate(val?.createdAt, true)}
                          </td>
                          <td>{val?.your_share || "0.00"}%</td>
                          <td>{val?.share || "0.00"}%</td>
                          <td>
                            <Button
                              onClick={() =>
                                navigate(`/wallet/history`, {
                                  state: {
                                    name: val.name,
                                  },
                                })
                              }>
                              View
                            </Button>
                          </td>
                          <td>
                            {val.id !== 1 && (
                              <div className="d-flex justify-content-center">
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    checked={val.status}
                                    onChange={() => StatusChange(val.id)}
                                    id={`flexSwitchCheckDefault${val?.id}`}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`flexSwitchCheckDefault${val?.id}`}>
                                    {val.status ? "Active" : "Inactive"}
                                  </label>
                                </div>
                              </div>
                            )}
                          </td>
                          <td>
                            {val.id !== 1 && (
                              <div className="action-holder">
                                {isAllow?.includes(47) && (
                                  <div
                                    className="icon-holder"
                                    onClick={() => setModalEditShow(val?.id)}>
                                    <FontAwesomeIcon icon={faPenToSquare} />
                                  </div>
                                )}

                                {isAllow?.includes(48) && (
                                  <div
                                    className="icon-holder"
                                    onClick={() => {
                                      setRecordToDeleteId(val?.id);
                                      setModalDeleteShow(true);
                                    }}>
                                    <FontAwesomeIcon icon={faTrash} />
                                  </div>
                                )}

                                <div
                                  className="icon-holder"
                                  onClick={() =>
                                    handleMoneyAction("Credit", val?.id)
                                  }>
                                  <FontAwesomeIcon icon={faPlus} />
                                </div>
                                <div
                                  className="icon-holder"
                                  onClick={() =>
                                    handleMoneyAction("Debit", val?.id)
                                  }>
                                  <FontAwesomeIcon icon={faMinus} />
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-center">
                          No Data
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>

                {/* Money Action Modal */}
                <Modal
                  show={showMoneyModal}
                  onHide={() => setShowMoneyModal(false)}
                  centered>
                  <Modal.Header closeButton>
                    <Modal.Title>
                      {moneyAction === "Credit"
                        ? "Add Money (Credit)"
                        : "Deduct Money (Debit)"}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group>
                      <Form.Label>Enter Amount (₹)</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>₹</InputGroup.Text>
                        <Form.Control
                          type="number"
                          placeholder="Enter amount"
                          value={amount}
                          min={1}
                          onChange={(e) => setAmount(e.target.value)}
                          onKeyPress={(e) =>
                            !/[0-9]/.test(e.key) && e.preventDefault()
                          }
                        />
                      </InputGroup>
                    </Form.Group>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setShowMoneyModal(false)}>
                      Cancel
                    </Button>
                    <Button
                      variant={moneyAction === "Credit" ? "success" : "danger"}
                      onClick={handleMoneySubmit}
                      disabled={moneyLoading || !amount || Number(amount) <= 0}>
                      {moneyLoading
                        ? "Processing..."
                        : moneyAction === "Credit"
                          ? "Add Money"
                          : "Deduct Money"}
                    </Button>
                  </Modal.Footer>
                </Modal>

                <CustomPaginate
                  currentPage={data?.data?.current_page}
                  totalPages={data?.data?.total_pages}
                  handlePageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Add show={modalShow} onHide={() => setModalShow(false)} />
      <Edit show={modalEditShow} onHide={() => setModalEditShow(0)} />

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code !== 0}
      />

      <Delete_Points_Modal
        show={modalDeleteShow}
        handleDeleteRecord={handleDeleteRecord}
        onHide={() => setModalDeleteShow(false)}
      />
    </>
  );
};

export default Tables;
